import { combineReducers, Reducer } from 'redux';
import { reducer as wishlistExportReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/reducer';
import { reducer as wishlistsPrintReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/reducer';
import { reducer as wishlistsSendReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/reducer';
import { WishlistActionsAction, WishlistActionsState } from './types';

const reducer: Reducer<
  WishlistActionsState,
  WishlistActionsAction
> = combineReducers({
  export: wishlistExportReducer,
  print: wishlistsPrintReducer,
  send: wishlistsSendReducer,
});

export {
  reducer,
};
